import { put, takeLatest } from 'redux-saga/effects';
import { ManageModuli } from '../../reducers/r_index';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { new_moduli } }) {
    try {

        new_moduli.NumUtenti = 5;

        //per ogni campo object di new_moduli (es. MagDoc) itero i vari moduli e li metto a true
        for (let fieldName of Object.keys(new_moduli.MagDoc)) {
            new_moduli.MagDoc[fieldName] = true;
        }

        for (let fieldName of Object.keys(new_moduli.DistBase)) {
            new_moduli.DistBase[fieldName] = true;
        }
        for (let fieldName of Object.keys(new_moduli.Contabilita)) {
            new_moduli.Contabilita[fieldName] = true;
        }
        for (let fieldName of Object.keys(new_moduli.Generali)) {
            new_moduli.Generali[fieldName] = true;
        }

        //se sono i moduli di una licenza Enterprise attivo anche tutti i Verticali
        if (new_moduli.Verticali !== undefined)
            for (let fieldName of Object.keys(new_moduli.Verticali)) {
                new_moduli.Verticali[fieldName] = true;
            }

        yield put(ManageModuli.creators.setAllActiveSuccess({ new_moduli }));

    } catch (e) {
        yield put(ManageModuli.creators.setAllActiveFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(ManageModuli.types.SET_ALL_ACTIVE_REQUEST, runAction);
}